"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationList = exports.NOTIFICATIONS_INFINITE_KEY = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const lodash_es_1 = require("lodash-es");
const react_1 = require("react");
const useFetchNotifications_1 = require("../../../features/NotificationCenter/api/useFetchNotifications");
const Notifications_1 = require("../../../features/NotificationCenter/components/Notifications");
const useSocket_1 = require("../../../hooks/useSocket");
const models_1 = require("../../../models");
exports.NOTIFICATIONS_INFINITE_KEY = 'notificationsInfinite';
const NOTIFICATION_WIDGET_LIST_SOCKET_NAMESPACE = '/notification-center.notification-list';
const useNotificationList = () => {
    const { state: { user }, } = (0, frontend_infra_auth_1.useAuth)();
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const options = { page: 1, pageSize: Notifications_1.DEFAULT_NOTIFICATIONS_PAGE_SIZE };
    const fetchFeeds = (0, useFetchNotifications_1.useFetchNotifications)();
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const { initializeSocket, createDomainEventsListeners, disconnectSocket } = (0, useSocket_1.useSocket)();
    const onNotificationsCreated = (newNotification) => {
        const querykey = [exports.NOTIFICATIONS_INFINITE_KEY, options.page, options.pageSize];
        const notificationListQueryData = queryClient.getQueryData(querykey);
        const notificationListQueryDataCloned = (0, lodash_es_1.cloneDeep)(notificationListQueryData);
        if ((notificationListQueryDataCloned?.pages || []).length > 0) {
            const notificationListFirstPage = notificationListQueryDataCloned.pages?.[0];
            notificationListFirstPage?.results?.unshift(newNotification);
            queryClient.setQueryData(querykey, notificationListQueryDataCloned);
        }
    };
    (0, react_1.useEffect)(() => {
        initializeSocket(models_1.WebsocketApp.ship, NOTIFICATION_WIDGET_LIST_SOCKET_NAMESPACE, {
            userId: user?._id,
        });
        createDomainEventsListeners([
            {
                eventType: notification_center_models_1.WS_PUBLIC_NOTIFICATION_CREATED,
                callback: (response) => onNotificationsCreated(response.payload),
            },
        ]);
        return () => {
            disconnectSocket();
        };
    }, []);
    return (0, frontend_infra_reactquery_1.useInfiniteQuery)({
        queryKey: [exports.NOTIFICATIONS_INFINITE_KEY, options.page, options.pageSize],
        queryFn: async ({ pageParam = 1 }) => {
            try {
                return await fetchFeeds({
                    ...options,
                    page: pageParam,
                });
            }
            catch (e) {
                snackService.showError(translate('notification_center-list-load_error'));
                return Promise.reject(e);
            }
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.page * lastPage.pageSize < lastPage.total) {
                return lastPage.page + 1;
            }
            return undefined;
        },
        initialPageParam: 1,
    });
};
exports.useNotificationList = useNotificationList;
//# sourceMappingURL=getNotificationList.js.map